import {
  CheckTile,
  FormSection,
} from "../../../../components/propertyDescription/descriptionUi";
import { PROPERTY_PERMISSIONS } from "../../../CreateProperty/components/DescriptionForm/constants";
import FurnitureStatusField from "../../../CreateProperty/components/DescriptionForm/sections/FurnitureStatusField";
import {
  getPropertyPermissionYes,
  setPropertyPermissionValue,
} from "../../../../utils/propertyDescriptionPermissions";
import { useEditPropertyWizard } from "../EditPropertyWizardContext";

export default function AmenitiesSection() {
  const {
    allowPets,
    setAllowPets,
    gasIncluded,
    setGasIncluded,
    isAdm,
    setIsAdm,
    isFunished,
    setIsFunished,
    waterIncluded,
    setWaterIncluded,
  } = useEditPropertyWizard();

  const permissionFlags = {
    allow_pets: !!allowPets,
    water_included: !!waterIncluded,
    gas_included: !!gasIncluded,
    is_adm: !!isAdm,
  };

  const permissionSetters = {
    allow_pets: setAllowPets,
    water_included: setWaterIncluded,
    gas_included: setGasIncluded,
    is_adm: setIsAdm,
  };

  return (
    <FormSection
      title="Amenidades e permissões"
      description="Condições de uso e o que está incluso no valor."
    >
      <FurnitureStatusField value={isFunished} onChange={setIsFunished} />
      <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
        {PROPERTY_PERMISSIONS.map((permission) => (
          <CheckTile
            key={permission.attributeName}
            label={permission.label}
            checked={getPropertyPermissionYes(
              permissionFlags,
              permission.attributeName
            )}
            onChange={(next) =>
              setPropertyPermissionValue(
                permissionSetters,
                permission.attributeName,
                next ? 1 : 0
              )
            }
          />
        ))}
      </div>
    </FormSection>
  );
}
